// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__3lqmb","marketplaceStroke":"IconEmailAttention_marketplaceStroke__2xu8L","attentionStroke":"IconEmailAttention_attentionStroke__vYoEr"};